export const hubsOrderTypes = {
  FETCH_HUBS_ORDERS_LOADING: 'FETCH_HUBS_ORDERS_LOADING',
  FETCH_HUBS_ORDERS_SUCCESS: 'FETCH_HUBS_ORDERS_SUCCESS',
  FETCH_HUBS_ORDERS_FAILURE: 'FETCH_HUBS_ORDERS_FAILURE',
  CLEAR_HUBS_ORDERS: 'CLEAR_HUBS_ORDERS',

  FETCH_HUBS_ORDER_METRICS_LOADING: 'FETCH_HUBS_ORDER_METRICS_LOADING',
  FETCH_HUBS_ORDER_METRICS_SUCCESS: 'FETCH_HUBS_ORDER_METRICS_SUCCESS',
  FETCH_HUBS_ORDER_METRICS_FAILURE: 'FETCH_HUBS_ORDER_METRICS_FAILURE'
}